import { FormattedText } from '../types/banner/formatted-text';

export const isFormattedText = (value: any): value is FormattedText => {
  return (
    typeof value === 'object' && value !== null && typeof value.text === 'string' && typeof value.html === 'string'
  );
};
